import styled from 'styled-components'

export const Collapser = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  margin: 0.5rem 0.5rem 0.5rem 0;
  color: ${({ theme }) => theme.colors.text.primary};

  svg {
    width: 100%;
    height: auto;
  }
`
